import React, { useState, useEffect } from 'react';
import {
  TrophyOutlined,
  GiftOutlined,
  SettingOutlined,
  UserOutlined,
  MessageOutlined,
  ThunderboltOutlined
} from '@ant-design/icons';
import { LevelsTab } from './components/LevelsTab';
import { RulesTab } from './components/RulesTab';
import { ConfigTab } from './components/ConfigTab';
import { PlayersTab } from './components/PlayersTab';
import { MessagesTab } from './components/MessagesTab';
import { RolloverTab } from './components/RolloverTab';
import { useOutletContext } from 'react-router-dom';
import { useAdminSelector } from '../../contexts/AdminSelectorContext';

// Define context type from UserPanel
interface UserPanelOutletContext {
  activeGamificationTab?: string;
  onGamificationTabChange?: (tab: string) => void;
}

// Export gamification pages for Sidebar integration
export const gamificationPages = [
  {
    key: 'players',
    label: 'Jugadores',
    icon: <UserOutlined />,
    color: '#52c41a',
    description: 'Estadísticas y gestión de usuarios'
  },
  {
    key: 'levels',
    label: 'Niveles',
    icon: <TrophyOutlined />,
    color: '#fa8c16',
    description: 'Sistema de progresión y rangos'
  },
  {
    key: 'rules',
    label: 'Reglas & Canjes',
    icon: <GiftOutlined />,
    color: '#722ed1',
    description: 'Bonus automáticos y canjes de puntos'
  },
  {
    key: 'messages',
    label: 'Mensajes',
    icon: <MessageOutlined />,
    color: '#eb2f96',
    description: 'Constructor de plantilla de notificaciones'
  },
  {
    key: 'rollover',
    label: 'Rollover',
    icon: <ThunderboltOutlined />,
    color: '#fa541c',
    description: 'Control de rollover y anti-lavado'
  },
  {
    key: 'config',
    label: 'Configuración',
    icon: <SettingOutlined />,
    color: '#13c2c2',
    description: 'Ajustes del sistema de gamificación'
  }
];

export const Gamification: React.FC = () => {
  // Get context from UserPanel
  const context = useOutletContext<UserPanelOutletContext>();
  const { selectedAdminId } = useAdminSelector();
  const [activeTab, setActiveTab] = useState<string>(
    context?.activeGamificationTab || 'players'
  );

  // Sync with parent component
  useEffect(() => {
    if (context?.activeGamificationTab) {
      setActiveTab(context.activeGamificationTab);
    }
  }, [context?.activeGamificationTab]);

  // Key based on selectedAdminId forces re-mount of child tabs when viewMode changes
  const adminKey = selectedAdminId || '__all__';

  const renderActiveContent = () => {
    switch (activeTab) {
      case 'players':
        return <PlayersTab key={adminKey} />;
      case 'levels':
        return <LevelsTab key={adminKey} />;
      case 'rules':
        return <RulesTab key={adminKey} />;
      case 'messages':
        return <MessagesTab key={adminKey} />;
      case 'rollover':
        return <RolloverTab key={adminKey} />;
      case 'config':
        return <ConfigTab key={adminKey} />;
      default:
        return <PlayersTab key={adminKey} />;
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      {renderActiveContent()}
    </div>
  );
};
